"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpaceEventProperties = exports.getAllGateValuesForLogging = void 0;
const utils_1 = require("gather-common/dist/src/public/utils");
const constants_1 = require("./constants");
const lodash_1 = require("lodash");
const FEATURES_1 = require("../gatekeeping/FEATURES");
const gate_1 = require("gather-gates/dist/src/public/gate");
const space_1 = require("gather-common/dist/src/public/resources/space");
const ts_utils_1 = require("gather-common/dist/src/public/ts-utils");
exports.getAllGateValuesForLogging = (0, lodash_1.memoize)((userId, spaceId, spaceCreationDate, gate) => Object.keys((0, FEATURES_1.getFeatures)()).reduce((allGates, currentGateKey) => {
    const featureGateName = (0, ts_utils_1.enumFromValue)(currentGateKey, FEATURES_1.GatedFeatName);
    const feature = (0, gate_1.getFeature)((0, FEATURES_1.getFeatures)(), featureGateName);
    if (!userId && !feature.space)
        return allGates;
    if (!spaceId && feature.space)
        return allGates;
    if (spaceCreationDate === "NOT_AVAILABLE") {
        if (feature.onlyEnableIfSpaceCreatedAfterDate ||
            feature.onlyEnableIfSpaceCreatedBeforeDate) {
            return allGates;
        }
        return {
            ...allGates,
            [currentGateKey]: gate(featureGateName, userId, spaceId),
        };
    }
    return {
        ...allGates,
        [currentGateKey]: gate(featureGateName, userId, spaceId, spaceCreationDate),
    };
}, {}), (userId, spaceId, spaceCreationDate) => `${userId || ""}-${spaceId || ""}-${spaceCreationDate || ""}`);
const getSpaceEventProperties = (dataSource, spaceId) => {
    const { getGameSpace, getSpaceInfo, getSpaceCapacity, getNumUsersNearby, getSpaceMembers, getMyPlayerId, getDynamicAvStrategy, gate, } = dataSource;
    const spaceInfo = getSpaceInfo();
    const gameSpace = getGameSpace(spaceId);
    const myPlayer = gameSpace?.getPlayerGameState();
    const inPrivateSpace = Boolean(gameSpace?.getCurrentPrivateArea());
    const spaceCapacity = getSpaceCapacity(spaceId);
    const numUsersInSpace = gameSpace?.getNumOnlinePlayers() || 0;
    const spaceIsOverCapacity = spaceCapacity ? numUsersInSpace > spaceCapacity : undefined;
    const spaceMembers = getSpaceMembers();
    const id = getMyPlayerId() || "";
    const role = (0, utils_1.getRoleWithFallbackToGuestRole)(spaceMembers[id]?.role);
    const owners = Object.values(spaceMembers)
        .filter((user) => (0, utils_1.hasSpaceRole)(user.role, [space_1.CoreRole.Owner]))
        .map((user) => user.id);
    const spaceCreationDate = spaceInfo?.creationDate ? new Date(spaceInfo?.creationDate) : undefined;
    const gates = (0, exports.getAllGateValuesForLogging)(id, spaceInfo?.id || null, spaceCreationDate || "NOT_AVAILABLE", gate);
    return {
        spaceId: spaceInfo?.id,
        spaceName: spaceInfo?.name,
        numUsersInSpace,
        numUsersNearby: getNumUsersNearby(spaceId),
        inPrivateSpace,
        x: myPlayer?.x,
        y: myPlayer?.y,
        map: myPlayer?.map,
        mapName: gameSpace?.getMyPlayerMap()?.name,
        defaultMap: spaceInfo?.map,
        mapCategory: (spaceInfo?.map && constants_1.MAP_NAME_TO_CATEGORY[spaceInfo?.map]) || constants_1.MapCategory.OTHER,
        isOwner: (0, utils_1.hasSpaceRole)(role, [space_1.CoreRole.Owner]),
        isMember: (0, utils_1.isMemberRole)(role),
        owners,
        hasGuestList: !!spaceInfo?.hasGuestList,
        globalBuild: !!spaceInfo?.settings?.globalBuild,
        useCase: spaceInfo?.reason,
        avStrategy: getDynamicAvStrategy(spaceId),
        spaceCapacity,
        spaceIsOverCapacity,
        gates,
        chatDisabled: !!spaceInfo?.settings?.disableChat,
    };
};
exports.getSpaceEventProperties = getSpaceEventProperties;
//# sourceMappingURL=getSpaceEventProperties.js.map